@if (!displayCustomContent) {
    @if ((customFormControl.touched || displayErrorOnInputChangeRealTime) && customFormControl.errors) {
        <p [id]="fieldId + '-' + errorKey + '-validation-error'" class="p-error">
            {{ errorMessage }}
        </p>
    }
} @else {
    <ng-content></ng-content>
}
